import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext"; // <Icon name="checkCircle" size={14} className="inline mr-1"/> ADD THIS
import { LanguageProvider } from "./context/LanguageContext";
import { detectShell } from "./utils/appShell";

// Opened from the Android app? Remembered before anything renders (utils/appShell).
detectShell();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </AuthProvider>
  </React.StrictMode>
);
